import { createAsyncThunk } from '@reduxjs/toolkit';
import { ax } from 'services/apiService';

export const getAmplifierList = createAsyncThunk('amplifier-list', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`automate/get_all_amplifier`, payload);
        return data;
    } catch (error) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const addAmplifier = createAsyncThunk('add_amplifier', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`automate/save_amplifier`, payload);
        return data;
    } catch (error) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// automate/delete_amplifier/1
export const deleteAmplifier = createAsyncThunk('delete_amplifier', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`automate/delete_amplifier/${id}`);
        return data;
    } catch (error) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});